"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverseOpeningStockParamsSchema = exports.importOpeningStockSchema = exports.openingStockRowSchema = void 0;
const zod_1 = require("zod");
const opening_stock_1 = require("../domain/opening-stock");
/**
 * One sheet line, every cell exactly as typed — the server parses it (`domain/opening-stock.ts`) and says what is wrong with it. A blank cell is NOT
 * a reason to refuse the whole sheet: it comes back as an error on its own row ("The batch number is missing"), so the clerk fixes one line.
 */
exports.openingStockRowSchema = zod_1.z.object({
    /** The drug code (Drug master) or item code (General Stores item) of what is on the shelf. */
    code: zod_1.z.string().trim().max(30),
    batchNumber: zod_1.z.string().trim().max(50),
    expiry: zod_1.z.string().trim().max(20).default(''),
    /** In ISSUE units (the unit it is sold in: tablets, vials ...). */
    quantity: zod_1.z.string().trim().max(20),
    /** Rupees per issue unit. */
    unitCost: zod_1.z.string().trim().max(20),
    mrp: zod_1.z.string().trim().max(20).default(''),
    gstPercent: zod_1.z.string().trim().max(10).default(''),
    rackCode: zod_1.z.string().trim().max(40).default(''),
    allowDiscount: zod_1.z.string().trim().max(10).default(''),
});
exports.importOpeningStockSchema = zod_1.z.object({
    locationId: zod_1.z.string().uuid(),
    /** The date the quantities are true on (not in the future), YYYY-MM-DD. */
    asOnDate: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'As-on date must be YYYY-MM-DD'),
    /** true = check every row and change nothing (the default); false = load the rows (only when every row passed). */
    dryRun: zod_1.z.boolean().default(true),
    rows: zod_1.z.array(exports.openingStockRowSchema).min(1).max(opening_stock_1.OPENING_STOCK_MAX_ROWS),
});
exports.reverseOpeningStockParamsSchema = zod_1.z.object({ runId: zod_1.z.string().uuid() });
//# sourceMappingURL=opening-stock.schema.js.map